import { isSaasCommercialBuyer } from "@/lib/accountStatus";
import {
  requiresAccessContextSelection,
  resolvePathAfterAccessContext,
} from "@/lib/workspaceAccessContext";

/**
 * ¿Debe usar Centro SaaS / plataforma (no flujo comprador de solicitud)?
 * Prioridad: diseñador/plataforma antes que validación trial/licencia comprador.
 * @param {object|null|undefined} user
 * @param {{ permissions?: object, platform?: object }|null} [capabilities]
 */
export function hasPlatformCenterAccess(user = null, capabilities = null) {
  if (!user) return false;

  const designerRole = Boolean(
    user.is_platform_designer
    || user.role === "platform_designer"
    || user.is_designer_backdoor,
  );
  if (designerRole && !isSaasCommercialBuyer(user)) {
    return true;
  }

  if (capabilities && !isSaasCommercialBuyer(user)) {
    if (capabilities.platform?.is_platform_designer) return true;
    if (capabilities.permissions?.access_license_center) return true;
  }

  return false;
}

/**
 * Ruta destino tras login o sesión ya autenticada en pantallas públicas.
 * @param {object|null|undefined} user
 */
export function resolvePostLoginPath(user = null) {
  if (!user) return "/login";
  if (user.needs_trial_registration) return "/registro-inicial";
  if (user.password_recovery_only) return "/recuperacion-acceso";
  if (requiresAccessContextSelection(user)) return "/seleccionar-contexto";
  if (hasPlatformCenterAccess(user)) return "/platform";
  if (user.active_context_type === "auxiliary") {
    return resolvePathAfterAccessContext(user);
  }
  return "/";
}

/** Deep link comprador (?solicitar_licencia=1 | ?activar_licencia=1) en Configuración. */
export function isBuyerLicenseConfigDeepLink(pathname = "", search = "") {
  const path = String(pathname || "").split("?")[0];
  if (!path.includes("configuracion")) return false;
  const params = new URLSearchParams(String(search || ""));
  return params.get("solicitar_licencia") === "1" || params.get("activar_licencia") === "1";
}
